import { render } from "./ProfileSupprimerCompte.vue?vue&type=template&id=24f98854"
import script from "./ProfileSupprimerCompte.vue?vue&type=script&lang=js"
export * from "./ProfileSupprimerCompte.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__